import { User } from '@/models/User';

export class Customer extends User {
  protected $name: string = 'Customer';
  protected $fillable: string[] = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'school', 'email', 'password', 'teacher', 'phone', 'roles'];

  protected filters: object = {
    role: 'customer',
  };

  public id?: string;
  public name?: string;
  public created_at?: string;
  public updated_at?: string;
  public avatar?: string;
  public dob?: string;
  public email?: string;
  public school?: string;
  public phone?: string;


  public url() {
    return '/customers/' + this.id;
  }
}
